import { Badge, Box, Stack, Text, ThemeIcon, Title } from "@repo/ui/core";
import { IconSparkles } from "@repo/ui/icons";
import { motion } from "framer-motion";
import classes from "@styles/onsite.module.css";

type Props = {
  title: string;
  feature: string;
  description: string;
};

export function ComingSoonSlide({ title, feature, description }: Props) {
  return (
    <Box w="100%" maw={1100} px="xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Stack gap="xl" align="center">
          <Badge
            size="xl"
            variant="light"
            color="violet"
          >
            {title}
          </Badge>

          <ThemeIcon
            size={88}
            radius="xl"
            variant="light"
            color="violet"
          >
            <IconSparkles size={44} />
          </ThemeIcon>

          <Title order={2} ta="center" size="clamp(32px, 4.5vw, 56px)" fw={800} className={classes.gradientTextViolet}>
            {feature}
          </Title>

          <Text size="xl" c="dimmed" ta="center" maw={700} lh={1.7}>
            {description}
          </Text>
        </Stack>
      </motion.div>
    </Box>
  );
}
